/**
 * Input Schema of CargaFoto
 * @author Simpli CLI generator
 */
import {Schema, FieldSet, FieldComponent, Component} from 'simpli-web-sdk'
import {CargaFoto} from '@/model/resource/CargaFoto'
import {CargaCollection} from '@/model/collection/CargaCollection'

/* TODO: review generated schema */
export class InputCargaFotoSchema extends Schema {
  collectionCarga = new CargaCollection().noPagination()

  readonly name = 'InputCargaFoto'

  readonly fieldSet: FieldSet<CargaFoto> = {
    carga: (schema): FieldComponent => ({
      is: Component.InputSelect,
      bind: {
        label: this.translateFrom(schema.fieldName),
        items: this.collectionCarga.all(),
      },
    }),
    urlImagem: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 511,
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required|url',
      },
    }),
    ehOcorrencia: (schema): FieldComponent => ({
      is: Component.InputCheckbox,
      bind: {
        label: this.translateFrom(schema.fieldName),
        class: 'pretty p-switch p-fill justify-center mt-8',
        labelClass: 'relative state',
      },
    }),
    reprocessar: (schema): FieldComponent => ({
      is: Component.InputCheckbox,
      bind: {
        label: this.translateFrom(schema.fieldName),
        class: 'pretty p-switch p-fill justify-center mt-8',
        labelClass: 'relative state',
      },
    }),
    urlBackup: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 511,
        label: this.translateFrom(schema.fieldName),
      },
    }),
  }
}
